<div class="min-h-screen bg-sakoo-bg flex">
  <!-- SIDEBAR DESKTOP -->
  <aside
    [class.lg:w-64]="!sidebarCollapsed()"
    [class.lg:w-20]="sidebarCollapsed()"
    class="hidden lg:flex lg:flex-col bg-white text-slate-700 border-r border-sakoo-border shrink-0 transition-all duration-300 ease-in-out"
  >
    <!-- Logo Header -->
    <div
      [class.px-6]="!sidebarCollapsed()"
      [class.justify-center]="sidebarCollapsed()"
      class="h-16 flex items-center gap-3 border-b border-sakoo-border transition-all duration-300"
    >
      <img src="img/sakoo_icon.png" alt="Sakoo" draggable="false" class="h-8 w-8 object-contain shrink-0 select-none" />
      @if (!sidebarCollapsed()) {
        <span class="text-xl font-bold text-slate-800 tracking-tight animate-in fade-in duration-200">
          Sakoo <span class="text-sakoo-green">BO</span>
        </span>
      }
    </div>

    <!-- Navigation Links -->
    <nav class="flex-1 py-6 px-4 space-y-1.5">
      <!-- Panel de Control oculto temporalmente
      <a
        routerLink="/dashboard"
        routerLinkActive="bg-sakoo-green/15 text-slate-800 font-bold border-l-4 border-sakoo-green"
        [routerLinkActiveOptions]="{ exact: true }"
        [attr.title]="sidebarCollapsed() ? 'Panel de Control' : null"
        [class.justify-center]="sidebarCollapsed()"
        [class.px-4]="!sidebarCollapsed()"
        [class.px-2]="sidebarCollapsed()"
        class="flex items-center gap-3 py-3 rounded-lg text-sm font-semibold hover:bg-slate-50 hover:text-slate-900 transition-all text-slate-600 border-l-4 border-transparent"
      >
        <svg lucideLayoutDashboard class="h-5 w-5 shrink-0"></svg>
        @if (!sidebarCollapsed()) {
          <span class="animate-in fade-in duration-200">Panel de Control</span>
        }
      </a>
      -->
      <a
        routerLink="/rates"
        routerLinkActive="bg-sakoo-green/15 text-slate-800 font-bold border-l-4 border-sakoo-green"
        [attr.title]="sidebarCollapsed() ? 'Tasas de Cambio' : null"
        [class.justify-center]="sidebarCollapsed()"
        [class.px-4]="!sidebarCollapsed()"
        [class.px-2]="sidebarCollapsed()"
        class="flex items-center gap-3 py-3 rounded-lg text-sm font-semibold hover:bg-slate-50 hover:text-slate-900 transition-all text-slate-600 border-l-4 border-transparent"
      >
        <svg lucideTrendingUp class="h-5 w-5 shrink-0"></svg>
        @if (!sidebarCollapsed()) {
          <span class="animate-in fade-in duration-200">Tasas de Cambio</span>
        }
      </a>
    </nav>

    <!-- Footer Info -->
    <div class="p-4 border-t border-sakoo-border text-xs text-slate-400 text-center font-medium transition-all duration-300">
      @if (!sidebarCollapsed()) {
        v1.0.0 &copy; 2026 Sakoo
      } @else {
        v1.0
      }
    </div>
  </aside>

  <!-- MOBILE SIDEBAR OVERLAY / SHELL -->
  @if (mobileSidebarOpen()) {
    <div class="fixed inset-0 z-50 flex lg:hidden bg-slate-900/40 backdrop-blur-xs transition-opacity duration-300">
      <div class="w-64 bg-white text-slate-700 flex flex-col h-full animate-in slide-in-from-left duration-200 border-r border-sakoo-border">
        <!-- Mobile Header -->
        <div class="h-16 flex items-center justify-between px-6 border-b border-sakoo-border">
          <div class="flex items-center gap-2">
            <img src="img/sakoo_icon.png" alt="Sakoo" draggable="false" class="h-7 w-7 object-contain select-none" />
            <span class="text-lg font-bold text-slate-800">Sakoo <span class="text-sakoo-green">BO</span></span>
          </div>
          <button (click)="closeMobileSidebar()" class="text-slate-500 hover:text-slate-800 focus:outline-none">
            <svg lucideX class="h-5 w-5"></svg>
          </button>
        </div>

        <!-- Mobile Navigation -->
        <nav class="flex-1 py-6 px-4 space-y-1.5">
          <!-- Panel de Control oculto temporalmente
          <a
            routerLink="/dashboard"
            routerLinkActive="bg-sakoo-green/15 text-slate-800 font-bold border-l-4 border-sakoo-green"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="closeMobileSidebar()"
            class="flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-semibold text-slate-600 border-l-4 border-transparent hover:bg-slate-50 hover:text-slate-900 transition-all"
          >
            <svg lucideLayoutDashboard class="h-5 w-5"></svg>
            Panel de Control
          </a>
          -->
          <a
            routerLink="/rates"
            routerLinkActive="bg-sakoo-green/15 text-slate-800 font-bold border-l-4 border-sakoo-green"
            (click)="closeMobileSidebar()"
            class="flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-semibold text-slate-600 border-l-4 border-transparent hover:bg-slate-50 hover:text-slate-900 transition-all"
          >
            <svg lucideTrendingUp class="h-5 w-5"></svg>
            Tasas de Cambio
          </a>
        </nav>

        <div class="p-4 border-t border-sakoo-border text-xs text-slate-400 text-center">
          v1.0.0 &copy; 2026 Sakoo
        </div>
      </div>
      <!-- Click outside sidebar to close -->
      <div class="flex-1" (click)="closeMobileSidebar()"></div>
    </div>
  }

  <!-- MAIN CONTAINER -->
  <div class="flex-1 flex flex-col min-w-0">
    <!-- TOP HEADER -->
    <header class="h-16 bg-white border-b border-sakoo-border px-6 flex items-center justify-between shrink-0 shadow-xs">
      <!-- Left side: Hamburger button / Sidebar Toggle + Breadcrumbs -->
      <div class="flex items-center gap-4">
        <button
          (click)="openMobileSidebar()"
          class="lg:hidden text-slate-600 hover:text-slate-900 focus:outline-none p-1 rounded-lg hover:bg-slate-100"
        >
          <svg lucideMenu class="h-6 w-6"></svg>
        </button>

        <!-- Desktop Sidebar Expand/Collapse Button -->
        <button
          (click)="toggleSidebar()"
          class="hidden lg:flex text-slate-600 hover:text-slate-900 focus:outline-none p-1.5 rounded-lg hover:bg-slate-100 transition-all duration-300"
        >
          <svg lucideMenu class="h-5 w-5"></svg>
        </button>
        
        <div class="flex items-center gap-2 text-sm font-medium text-slate-500">
          <span class="text-slate-400">BackOffice</span>
          <span class="text-slate-300">/</span>
          <span class="text-slate-800 font-semibold uppercase tracking-wider text-xs bg-slate-100 px-2 py-0.5 rounded">
            Admin
          </span>
        </div>
      </div>

      <!-- Right side: Profile and Logout -->
      <div class="flex items-center gap-4">
        <div class="hidden sm:flex flex-col items-end text-right">
          <span class="text-xs font-semibold text-slate-600 bg-slate-100 px-2.5 py-1 rounded-md">
            Administrador
          </span>
        </div>
        
        <div class="h-8 w-px bg-slate-200"></div>

        <hlm-alert-dialog>
          <button
            hlmAlertDialogTrigger
            hlmBtn
            variant="ghost"
            size="sm"
            class="gap-1.5 text-xs font-semibold text-slate-600 hover:text-rose-500 hover:bg-rose-50 rounded-lg"
          >
            <svg lucideLogOut class="h-4 w-4"></svg>
            <span class="hidden xs:inline">Cerrar Sesión</span>
          </button>

          <hlm-alert-dialog-content *hlmAlertDialogPortal="let ctx">
            <hlm-alert-dialog-header>
              <h2 hlmAlertDialogTitle>¿Cerrar sesión?</h2>
              <p hlmAlertDialogDescription>
                Se cerrará tu sesión actual y volverás a la pantalla de inicio de sesión.
              </p>
            </hlm-alert-dialog-header>
            <hlm-alert-dialog-footer>
              <button hlmAlertDialogCancel (click)="ctx.close()">Cancelar</button>
              <button hlmAlertDialogAction (click)="logout()">Cerrar Sesión</button>
            </hlm-alert-dialog-footer>
          </hlm-alert-dialog-content>
        </hlm-alert-dialog>
      </div>
    </header>

    <!-- ROUTER CONTENT AREA -->
    <main class="flex-1 overflow-y-auto bg-sakoo-bg">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
